import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.auctions')
  .filter('score', score);

/* @ngInject */
function score($filter) {
  return function (auctionOffer) {
    const score = _.get(auctionOffer, 'courierScore.score', null);
    return _.isNull(score) ? 'N/A' : $filter('number')(score, 1) + '%';
  }
}
